export default __webpack_public_path__ + "static/media/spt17.b55b6278.jpg";